import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "ui/components/collapsible";
import { Link, useLocation } from "react-router-dom";
import {
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
} from "ui/components/sidebar";
import { Badge } from "ui/components/badge";
import { PermissionGate } from "permissions/components/gate";
import { ChevronRight } from "lucide-react";
import { Icon } from "components";
import { usePermissions } from "contexts/permission";
import { useState } from "react";

// 3. Base Navigation Components
export function NavItem({
  title,
  url = "",
  icon,
  requiredPermissions,
  children,
  badge,
  className = "",
  rule,
  defaultOpen = false,
  collection,
  matchExact,
  ...props
}) {
  const permissions = usePermissions();

  const location = useLocation();
  const isBaseMatch = defaultOpen || (url && location.pathname.startsWith(url));

  const [open, setOpen] = useState(isBaseMatch);

  function isActiveLink(currentPath, targetPath, exact = false) {
    const normalizedPath = targetPath.replace(/\/$/, "");
    return exact
      ? currentPath === normalizedPath
      : currentPath === normalizedPath ||
          currentPath.startsWith(normalizedPath + "/");
  }

  const isActive = isActiveLink(location.pathname, url, matchExact);

  // console.log(
  //   "requiredPermissions",
  //   requiredPermissions,
  //   permissions.evaluatePermission(requiredPermissions),
  // );

  if (!permissions.evaluatePermission(requiredPermissions)) {
    return null;
  }

  const renderContent = () => {
    if (children) {
      return (
        <Collapsible
          asChild
          className="group/collapsible"
          defaultOpen={isBaseMatch}
          open={open}
          onOpenChange={setOpen}
        >
          <SidebarMenuItem>
            <CollapsibleTrigger asChild>
              <SidebarMenuButton
                tooltip={title}
                className={className}
                data-active={url && isActive}
                {...props}
                asChild
              >
                <Link to={url}>
                  {icon && <Icon icon={icon} />}
                  <span>{title}</span>
                  <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                </Link>
              </SidebarMenuButton>
            </CollapsibleTrigger>
            <CollapsibleContent>
              <SidebarMenuSub>{children}</SidebarMenuSub>
            </CollapsibleContent>
          </SidebarMenuItem>
        </Collapsible>
      );
    }

    return (
      <SidebarMenuItem>
        <SidebarMenuButton
          asChild
          className={className}
          data-active={isActive}
          {...props}
        >
          <Link to={url} className="flex items-center">
            {icon && <Icon icon={icon} />}
            <span>{title}</span>

            {badge && <div className="ml-auto">{badge}</div>}
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    );
  };

  if (rule) {
    return (
      <PermissionGate rule={rule} collection={collection}>
        {renderContent()}
      </PermissionGate>
    );
  }

  return renderContent();
}
